import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'local_shipping_providers',
            name: 'localShippingProviders',
            class: 'Modules\\Ecommerce\\Entities\\LocalShippingProviders'
        }
    }
}